import { ISearchCompanyRequestParams } from "./types";

export const DEFAULT_SEARCH_COMPANY_PAGING: ISearchCompanyRequestParams["paging"] = {
  page: 1,
  pageSize: 10
};
